export default class Address {
  constructor(args = {}) {
    args = args || {}
    this.city = args.city || ""
    this.street = args.street || ""
    this.state = args.state || ""
    this.postalCode = args.postalCode || ""
  }
}
